import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import InputField from '../InputField';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

const EducationForm = ({
  collapsed,
  setCollapsed,
  education,
  setEducation
}) => {
  const [formData, setFormData] = useState({
    school: '',
    degree: '',
    from: new Date(),
    to: new Date(),
    state: '',
    country: ''
  });

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    // console.log(formData);
    setEducation([
      ...education,
      {
        school: formData?.school,
        degree: formData?.degree,
        startDate: formData?.from,
        endDate: formData?.to,
        state: formData?.state,
        country: formData?.country
      }
    ]);
    setFormData({
      school: '',
      degree: '',
      from: new Date(),
      to: new Date(),
      state: '',
      country: ''
    });
    setCollapsed(!collapsed);
  };

  const options = ['ADN/ASN', 'BS/BSN', 'MSN/MBA', 'PHD', 'DNP'];

  return (
    <Form onSubmit={handleSubmit}>
      <InputField
        value={formData.school}
        label="School"
        name="school"
        handleChange={handleChange}
      />
      <Form.Group as={Row} className="mb-3" controlId="degree">
        <Col sm={{ span: 7, offset: 3 }}>
          <Form.Select
            onChange={e =>
              setFormData(prevState => {
                return { ...prevState, degree: e.target.value };
              })
            }
            size="sm"
            required
          >
            <option value="">Select Education</option>
            {options.map(option => (
              <option key={option}>{option}</option>
            ))}
          </Form.Select>
        </Col>
      </Form.Group>
      <InputField
        value={formData.state}
        label="State"
        name="state"
        handleChange={handleChange}
      />
      <InputField
        value={formData.country}
        label="Country"
        name="country"
        handleChange={handleChange}
      />

      <Form.Group as={Row} className="mb-3" controlId={name}>
        <Form.Label column sm={3} className="text-lg-end">
          From
        </Form.Label>
        <Col sm={9} md={7}>
          <DatePicker
            selected={formData.from}
            onChange={date => setFormData({ ...formData, from: date })}
            className="form-control form-control-sm"
            placeholderText="Select Date"
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId={name}>
        <Form.Label column sm={3} className="text-lg-end">
          To
        </Form.Label>
        <Col sm={9} md={7}>
          <DatePicker
            selected={formData.to}
            onChange={date => setFormData({ ...formData, to: date })}
            className="form-control form-control-sm"
            placeholderText="Select Date"
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Col sm={{ span: 10, offset: 3 }}>
          <Button type="submit">Save</Button>
        </Col>
      </Form.Group>
    </Form>
  );
};

EducationForm.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  education: PropTypes.any,
  setEducation: PropTypes.func.isRequired
};

export default EducationForm;
